import(/* webpackMode: "eager" */ "/app/apps/shop/src/components/modals/ProductDetailsModal/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/shop/src/components/sections/DynamicSections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/sections/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/shop/src/components/sections/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_eocq57jkeunibbsz7bxjvo46qq/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_eocq57jkeunibbsz7bxjvo46qq/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
